import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "vxe-icon-spinner roll vxe-loading--default-icon"
};
const _hoisted_2 = {
  key: 1,
  class: "vxe-input--search-icon vxe-icon-search"
};
import { useMgOrgUserPicker } from '@/share/components/xeui/mg-org-user-picker';

import { inject, ref, reactive, watch } from 'vue';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-org-user-picker-input',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const $xeForm = inject('$xeForm');
    const xeFormItemInfo = inject('xeFormItemInfo');
    const loading = ref(false);
    const props = __props;
    const state = reactive({
      userId: '',
      username: '',
      inputValue: ''
    });
    const {
      showMgOrgUserPicker
    } = useMgOrgUserPicker();
    const doInputChanged = () => {
      if ($xeForm) {
        const {
          field
        } = xeFormItemInfo || {};
        if (field) {
          $xeForm.validateField(field);
        } else {
          $xeForm.validate();
        }
      }
    };
    const {
      runAsync: myOrgSearchUserApi
    } = fetchApi('org.myOrgSearchUser', {
      showError: false
    });
    const {
      runAsync: getUsernamesApi
    } = fetchApi('user.getUsernames', {
      showError: false
    });
    // 根据id获取用户名称
    const getUsername = async userId => {
      loading.value = true;
      const {
        error,
        data
      } = await getUsernamesApi({
        ids: [userId]
      });
      loading.value = false;
      if (error) {
        return '';
      }
      return (data || {})[userId] || '';
    };
    const doSearchUser = async search => {
      loading.value = true;
      const {
        error,
        count,
        info
      } = await myOrgSearchUserApi({
        search
      });
      loading.value = false;
      if (error) return Promise.resolve(false);
      if (count === 0 || count > 1 || !info) {
        // 没找到或有多个时，弹窗选择
        return handleSearchClick({
          value: search
        });
      }
      const {
        id,
        nickname
      } = info || {};
      state.username = nickname;
      state.inputValue = nickname;
      state.userId = id;
      emit('update:modelValue', state.userId);
      doInputChanged();
    };
    watch(() => state.userId, val => {
      if (val) {
        if (state.username === '') {
          getUsername(val).then(s => {
            state.username = s;
            state.inputValue = s;
          });
        }
      } else {
        state.inputValue = '';
        state.username = '';
      }
    }, {
      immediate: true
    });
    watch(() => props.modelValue, val => {
      if (val !== state.userId) {
        state.userId = val;
      }
    }, {
      immediate: true
    });
    const handleKeydownEnterEvent = () => {
      if (state.inputValue) {
        doSearchUser(state.inputValue);
      } else {
        handleSearchClick({
          value: ''
        });
      }
    };
    const handleBlueEvent = () => {
      let newValue = state.inputValue;
      let newId = state.userId;
      if (state.userId === '') {
        if (state.inputValue !== '') {
          return doSearchUser(state.inputValue);
        } else {
          newValue = '';
        }
      } else if (state.userId) {
        if (state.inputValue === '') {
          newId = '';
        } else if (state.inputValue !== state.username) {
          newValue = state.username;
        }
      }
      if (newId !== state.userId) {
        emit('update:modelValue', newId);
      }
      Object.assign(state, {
        username: newValue,
        inputValue: newValue,
        userId: newId
      });
      doInputChanged();
    };
    const handleSearchClick = async () => {
      if (loading.value) return;
      const row = await showMgOrgUserPicker('选择用户', {
        multiple: false,
        search: state.inputValue
      });
      if (!row || row.length === 0) {
        if (state.userId === '') {
          state.username = '';
          state.inputValue = '';
        } else {
          state.inputValue = state.username;
        }
        return Promise.resolve(false);
      }
      const {
        id,
        nickname
      } = row[0];
      Object.assign(state, {
        username: nickname,
        inputValue: nickname,
        userId: id
      });
      emit('update:modelValue', state.userId);
      doInputChanged();
      return Promise.resolve(true);
    };
    const handleClearClick = () => {
      state.inputValue = '';
      state.username = '';
      state.userId = '';
      emit('update:modelValue', state.userId);
    };
    const handleModelValueChange = value => {
      state.inputValue = value;
    };
    return (_ctx, _cache) => {
      const _component_vxe_input = _resolveComponent("vxe-input");
      return _openBlock(), _createBlock(_component_vxe_input, {
        onKeydown: _withKeys(handleKeydownEnterEvent, ["enter"]),
        onBlur: handleBlueEvent,
        clearable: "",
        onSearchClick: handleSearchClick,
        onClear: handleClearClick,
        onDblclick: handleSearchClick,
        "model-value": _unref(state).inputValue,
        "onUpdate:modelValue": handleModelValueChange
      }, {
        suffix: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(['vxe-input--control-icon', {
            'is--disabled': _unref(loading)
          }]),
          onClick: _withModifiers(handleSearchClick, ["stop"])
        }, [_unref(loading) ? (_openBlock(), _createElementBlock("i", _hoisted_1)) : (_openBlock(), _createElementBlock("i", _hoisted_2))], 2)]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};